export const Colors = [
	{
		name: "Purple",
		hex: "#6d55ce",
	},
	{
		name: "Pink",
		hex: "#cf91d8"
	},
	{
		name: "Blue",
		hex: "#0091ff"
	},
	{
		name: "Light Blue",
		hex: "#5fd4f4"
	},
	{
		name: "Teal",
		hex: "#2ebde5"
	},
	{
		name: "Green",
		hex: "#46a758"
	},
	{
		name: "Orange",
		hex: "#ffa01c"
	},
	{
		name: "Red",
		hex: "#e5484d"
	}
]